var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents-box"},[_c('div',{staticClass:"contents"},[_c('p',{staticClass:"contents-title"},[_vm._v("您的MOVIBOT账户"+_vm._s(_vm.statustext))]),_vm._v(" "),_c('router-link',{staticClass:"contents-a",attrs:{"to":{ name: 'login' }}},[_vm._v("登录账号")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bab900","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/activate.vue
// module id = null
// module chunks = 